import React from 'react'
import AdminField from '../../../layout/AdminField'
import { Divider, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'

function CampaignFields(props:any) {

    const {
        campaign,
        errors,
        titleInput,
        setTitleInput,
        handleFieldChange,
        openImagePicker,
        openVideoPicker,
        tabValue
    } = props

  return <>
    <div
          role="tabpanel"
          hidden={tabValue !== 0}
          id="simple-tabpanel-0"
          aria-labelledby="simple-tab-0"
        >
          <Grid container spacing={4}>
            <AdminField
              label="Kampanya Başlığı"
              value={titleInput}
              onChange={(value) => setTitleInput(value)}
              error={!!errors.titleInput}
              errorMessage={errors.titleInput}
            />
            <AdminField
              label="Başlangıç Tarihi"
              type="date"
              value={campaign.startDate}
              onChange={(newValue) =>
                handleFieldChange("startDate", newValue || dayjs())
              }
              error={!!errors.startDate}
              errorMessage={errors.startDate}
            />
            <AdminField
              label="Bitiş Tarihi"
              type="date"
              value={campaign.endDate}
              onChange={(newValue) =>
                handleFieldChange("endDate", newValue || dayjs())
              }
              error={!!errors.endDate}
              errorMessage={errors.endDate}
            />
            <AdminField
              label="Yayında mı?"
              type="switch"
              value={campaign.isActive}
              onChange={(value) =>
                handleFieldChange("isActive", value)
              }
            />
            <AdminField
              label="Kullanıcı kaydı"
              type="radio"
              value={campaign.collectUserData}
              helperText="Oyun başında, sonunda veya farklı cihazdan kullanıcı bilgileri ile kayıt almak istiyorsanız bu ayarı düzenleyiniz"
              onChange={(value) =>
                handleFieldChange("collectUserData", parseInt(value))
              }
              selectOptions={[
                { label: "Kayıt Alma", value: 1 },
                { label: "Oyun Başında", value: 2 },
                { label: "Oyun Sonunda", value: 3 },
                { label: "Uzaktan (Mobil)", value: 4 },
              ]}
            />
          </Grid>

          <Divider sx={{ mb: 5 }} />
          <Typography variant="h5" gutterBottom sx={{ mb: 5 }}>
            Ek Bilgi Alanları
          </Typography>

          <Grid container spacing={4} sx={{ mb: 4 }}>
            <AdminField
              label="Açıklama"
              value={campaign.description}
              helperText="Etkinliğin açıklama metnini yazınız"
              onChange={(value) =>
                handleFieldChange("description", value)
              }
            />
            <AdminField
              label="Firma Adı"
              value={campaign.companyName}
              helperText="Etkinliğin yapılacağı firmanın adını yazınız"
              onChange={(value) =>
                handleFieldChange("companyName", value)
              }
            />
            <AdminField
              label="Etkinlik Yeri"
              value={campaign.venue}
              helperText="Etkinliğin yapılacağı yeri yazınız"
              onChange={(value) => handleFieldChange("venue", value)}
            />
          </Grid>

          <Divider sx={{ mb: 5 }} />
          <Typography variant="h5" gutterBottom sx={{ mb: 5 }}>
            Özelleştirme
          </Typography>
          
          <Grid container spacing={4} sx={{ mb: 4 }}>
            <AdminField
              label="Açılış ekranı var mı?"
              type="switch"
              value={campaign.hasStartScreen}
              onChange={(value) =>
                handleFieldChange("hasStartScreen", value)
              }
            />
            <AdminField
              label="Açılış Ekran Videosu"
              value={campaign.startVideo}
              onChange={(value) => handleFieldChange("startVideo", value)}
              helperText="Açılış ekranında veya uzaktan (mobil) oyunda video kullanacaksanız .mp4 formatında buradan ekleyiniz"
              type="button"
              buttonText="Video Galerisi'nden Seç"
              onClick={() => openVideoPicker("startVideo")}
            />
            <AdminField
              label="Ödül Yazısı"
              value={campaign.modalText}
              onChange={(value) => handleFieldChange("modalText", value)}
              helperText="Ödül popupı üzerindeki yazıyı değiştirmek istiyorsanız buradan düzenleyebilirsiniz."
            />
            <AdminField
              label="Pas/İflas Yazısı"
              value={campaign.modalPassText}
              onChange={(value) => handleFieldChange("modalPassText", value)}
              helperText="Ödül popupının pas gelmesi durumundaki yazısını buradan değiştirebilirsiniz."
            />
            <AdminField
              label="Ödül Popup Arkaplan"
              value={campaign.modalBg}
              onChange={(value) => handleFieldChange("modalBg", value)}
              helperText="Ödül popupına özel arkaplan kullanmak için buradan ekleyiniz"
              type="button"
              buttonText="Galeri'den Seç"
              onClick={() => openImagePicker("modalBg")}
            />
            <AdminField
              label="Ödül Popup İçi Arkaplan"
              value={campaign.modalInnerBg}
              onChange={(value) => handleFieldChange("modalInnerBg", value)}
              helperText="Ödül popupının kutusu içinde arkaplan kullanmak için buradan ekleyiniz"
              type="button"
              buttonText="Galeri'den Seç"
              onClick={() => openImagePicker("modalInnerBg")}
            />
            <AdminField
              label="Ödül kutu köşeleri yuvarlak mı?"
              type="switch"
              value={campaign.modalBorderRadius}
              onChange={(value) =>
                handleFieldChange("modalBorderRadius", value)
              }
            />
            <AdminField
              label="Ödül Popup Rengi"
              type="color"
              inline
              inlineFix={1}
              value={campaign.modalColor}
              onChange={(value) => handleFieldChange("modalColor", value)}
              helperText="Ödül popupının kutusunun rengini giriniz"
            />
            <AdminField
              label="Ödül Popup Yazı Rengi"
              type="color"
              inline
              inlineFix={4}
              value={campaign.modalTextColor}
              onChange={(value) => handleFieldChange("modalTextColor", value)}
              helperText="Ödül popupının kutusunun yazı rengini giriniz"
            />
            <AdminField
              label="Özel CSS"
              value={campaign.customCSS}
              helperText="Eğer oyun ekranında sadece bu kampanya için geçerli olacak görselleştirme uygulayacaksanız bu alan içinde özel CSS kullanınız."
              onChange={(value) => handleFieldChange("customCSS", value)}
              multiline
              rows={10}
            />
          </Grid>
        </div>
  </>
}

export default CampaignFields
